import { Popover } from 'antd';
import React from 'react';
import styles from './PopoverClue.module.scss'
import { Info } from '../../libs/corporate/icons/outlined/action/MainCollection';

interface PopoverClueProps {
    label?: string
    clues: string[];
}

export const PopoverClue: React.FC<PopoverClueProps> = (props) => {

    const content = (
        <div >
            {
                props.label ? 
                    <p>
                        {props.label}
                    </p>
                    : 
                null
            }
            {props.clues.map((fieldName, index) => (
                <React.Fragment key={index}>
                    {fieldName} 
                    <br/>
                </React.Fragment>
            ))}
        </div>
    );

    return (
        <div className={styles.popoverClueInfoWrapper}>
            <Popover
                getPopupContainer={() => document.body}
                content={content}
                trigger="click"
            >
                <button
                    type="button"
                    className={styles.popoverClueButton}
                >
                    <Info />
                </button>
            </Popover>
        </div>
    )
};